export default [
  { id: 'calls', text: 'Ligações' },
  { id: 'logins', text: 'Logins' },
  { id: 'status', text: 'Status' }
];
